import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ApprovedComponentList from './ApprovedComponentList';
import { getUserProfileWidget, getApprovedComponent, getUserOrgModelCategoryType } from '../../selectors/index';

import {
  getApprovedComponentThunk, saveApprovedComponentThunk, setApprovedComponentChangeThunk, setCurrentPage,
  setPageFilter, setApprovedComponentsFilteredDataThunk, resetModelComponentThunk
} from '../../actions/approvedComponents';

const mapStateToProps = state => {
  return {
    approvedComponent: getApprovedComponent(state),
    userProfileWidgets: getUserProfileWidget(state),
    userModelCategories: getUserOrgModelCategoryType(state)


  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setFilterData: filteredData => setApprovedComponentsFilteredDataThunk(filteredData),
      getApprovedComponent: (modelCategoryId, offset, limit, filter) => getApprovedComponentThunk({ offset, limit, filter }, 'APPROVEDCOMPONENT_LIST', modelCategoryId),
      saveApprovedComponent: (approvedComponent, widgetCode) => saveApprovedComponentThunk(approvedComponent, widgetCode),
      setApprovedComponentChange: selectedApprovedComponent => setApprovedComponentChangeThunk(selectedApprovedComponent),
      resetModelComponent: approvedComponent => resetModelComponentThunk(approvedComponent),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedComponentList);
